import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Link from '../../../link/link';
import PanelContext from '../../../sidebar/panel/panelContext';
import { panelType } from '../../../../../shared/constants';
import connectionType from '../../../../utils/connections/connectionType';

const articles = count => (count === 1 ? 'article' : 'articles');

export default function ConnectionListItem({
  count,
  description,
  id,
  type,
}) {
  const { openPanel } = useContext(PanelContext);

  const component = count === 1 ? panelType.connectionsArticlePreview : panelType.connections;

  const launchProps = { type };

  const memoizedOpenPanel = useCallback(
    () => openPanel({ component, launchProps }),
    [openPanel, component, launchProps],
  );

  return count > 0
    && (
      <li id={id}>
        <Link href="#" onClick={memoizedOpenPanel}>
          {`${count} ${articles(count)} ${description}`}
        </Link>
      </li>
    );
}

ConnectionListItem.propTypes = {
  count: PropTypes.number,
  description: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.oneOf(Object.values(connectionType)).isRequired,
};

ConnectionListItem.defaultProps = {
  count: 0,
  description: '',
  id: '',
};
